/* eslint-disable */
import { getItem } from "~/util/cookies";

const DEBUG = false;
const CONVERSIONS_ID = {
	PHOTO_LIKE: 100144547,
	PHOTO_UPLOAD: 100144546,
	ROUTE_PLAN: 100144543,
	REVIEW_SEND: 100144545,
};

function commonTest() {
	return (getItem("szncmpone") === "1" || DEBUG) && window.rc;
}

function getKeyByValue(object: object, value: number): string {
	return Object.keys(object).find(key => object[key] === value);
}

function conversionHit(id: number = 0): void {
	if (commonTest() && window.rc.conversionHit) {
		const conversionObj = {
			id,
			value: null
		};

		window.rc.conversionHit(conversionObj);
		/* eslint-disable no-console */
		DEBUG && console.log(["conversionHit", conversionObj, getKeyByValue(CONVERSIONS_ID, id)]);
	}
}

export function retargetingHit(): void {
	if (commonTest() && window.rc.retargetingHit) {
		const retargetingObj = {
			rtgId: 103734,
		};

		window.rc.retargetingHit(retargetingObj);
		/* eslint-disable no-console */
		DEBUG && console.log(["retargetingHit", retargetingObj]);
	}
}

export function sklikPhotoLike() {
	conversionHit(CONVERSIONS_ID.PHOTO_LIKE);
}

export function sklikPhotoUpload() {
	conversionHit(CONVERSIONS_ID.PHOTO_UPLOAD);
}

export function sklikRoutePlan() {
	conversionHit(CONVERSIONS_ID.ROUTE_PLAN);
}

export function sklikReviewSend() {
	conversionHit(CONVERSIONS_ID.REVIEW_SEND);
}
